<lns-spinner *ngIf="loading$ | async"></lns-spinner>

<router-outlet></router-outlet>
<lns-modal-error></lns-modal-error>
<lns-modal> </lns-modal>
<lns-alert> </lns-alert>

<main class="main" fxFlex="100">
  <router-outlet></router-outlet>
</main>
<main
  class="sidebar"
  [ngClass]="{ 'sidebar--open': sidebar.isActivated }"
  fxFlex="noshrink"
>
  <div class="sidebar__content">
    <router-outlet name="sidebar" #sidebar="outlet"></router-outlet>
  </div>
</main>
